module.exports = __webpack_public_path__ + "img/menu.8960042d.svg";